module.exports = __webpack_public_path__ + "static/product-card-badges-7af42319b71a1a2d34f4c9789d73305c.png";